import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/auth.context";
import Spinner from "../components/spinner";

/**
 * UserPrivateRoutes
 * - Uses authData.IsActive to decide access.
 * - While authLoading is true we render a spinner so the auth check can finish.
 * - If active: render <Outlet />
 * - Otherwise: redirect to /login and preserve attempted path in state.from and state.fromPage
 */
export const UserPrivateRoutes = () => {
  const { authData, authLoading } = useAuth();
  const location = useLocation();

  // console.log("UserPrivateRoutes location");
  // console.log(location);

  // while AuthProvider is checking session, render a spinner and do NOT redirect
  if (authLoading) {
    return <Spinner />; // <-- RETURN was missing in your original code
  }

  const isActive = !!authData && authData.IsActive === true;

  return isActive ? (
    <Outlet />
  ) : (
    // include both from and fromPage so the login page can read either convention
    <Navigate
      to="/login"
      state={{
        from: location,
      }}
      replace
    />
  );
};

export default UserPrivateRoutes;
